import { AudienceConnectInnerForGateway } from '../../../../MicrosoftAudienceModal/AudienceConnectInnerForGateway'
import { ConnectionStatus, PLATFORMS, Platforms } from '../../../models'
import React from 'react'

import { GoogleConnectionModal } from './Google/GoogleConnectionModal'
import { MetaConnectionModal } from './Meta/MetaConnectModal'

interface RenderConnectionModalProps {
  platform: Platforms
  connectionStatus: ConnectionStatus
  onClose: () => void
  isEnabled?: boolean
  isEdit?: boolean
}

export const RenderConnectionModal = ({
  platform,
  onClose,
  connectionStatus,
  isEnabled,
  isEdit,
}: RenderConnectionModalProps) => {
  switch (platform) {
    case PLATFORMS.GOOGLE:
      return (
        <GoogleConnectionModal
          onClose={onClose}
          connectionStatus={connectionStatus}
          isEdit={isEdit}
        />
      )
    case PLATFORMS.META:
      return (
        <MetaConnectionModal
          onClose={onClose}
          connectionStatus={connectionStatus}
          isEnabled={isEnabled}
        />
      )
    case PLATFORMS.MICROSOFT:
      return <AudienceConnectInnerForGateway onClose={onClose} />
    default:
      onClose()
      return <div />
  }
}
